import type { AdminStore } from 'services/api/admin';
import { ReactNode } from 'react';

export type KeywordType = 1 | 2 | 3 | 4 | 5;

export enum SearchScene {
  SpyClass = 0,
  ExpandSeed = 1,
  EditSkuGroup = 2,
}

export interface SearchProps {
  storeType: 0 | 1 | 2;
  keywordType: KeywordType;
  keyword: string;
  pageNo: number;
  pageSize: number;
  platformStoreScope: General.StoreScope[];
  tagId: string[];
  internalItemId: string[];
  categoryUniqueId: string[];
  /**
   * 筛选的单品id（选填）
   */
  includeSpuClassId?: string;
  scene?: SearchScene;
  /**
   * 知识id,scene=EXPAND_SEED时排出知识内的商品
   */
  knowledgeId?: number;
  /**
   * scene=EDIT_SKU_GROUP/EXPAND_SKU_GROUP
   */
  skuGroupHashKey?: number;
}

export type Params = Omit<SearchProps, 'storeType' | 'internalItemId'>;
export type ParamsWithSet = Params & {
  setParams: (params: Partial<Params>) => void;
};

export interface BaseProps {
  /** 控制商品选择器的列数 */
  column?: number; // > 1 使用瀑布流
  defaultSearchParams?: Partial<Params>; // 默认搜索参数
  defaultStores?: AdminStore[]; // 默认店铺(可选店铺范围)
  defaultStoreScopes?: General.StoreScope[]; // 默认店铺范围(可选店铺范围, 内部会转成店铺, 不同于defaultSearchParams.platformStoreScope)
  itemRender?: (item: ItemV5) => ReactNode;
  defaultSkuFoldStatus?: FoldState; // sku默认状态
  skuDisabled?: boolean; // 是否禁用sku
}

export type Category = {
  cid: string;
  name: string;
  cidPath: string[];
  namePath: string[];
  parentCid: string;
  count: number;
  platform: string;
  categoryUniqueId: string;
};

export type ItemV5 = ItemSelectV2.Item & {
  category?: Category;
  categoryUniqueId?: string;
};

export type FoldState = 'fold' | 'unfold';
